module.exports = __webpack_public_path__ + "static/media/003.99ec5bd7.jpg";